import React, { useRef, useState, useCallback, useEffect, useMemo } from 'react';
import { connect } from 'react-redux';

import { UpcomingExamsModal } from '../../../../components/modal';
import { Table } from '../../../../components/table';
import { getColumns } from './table/getColumns';

import {

} from '../../../../actions';

const defaultSorted = { dataField: 'has_exams', order: 'desc' };

function Component(props){
    const mounted = useRef(false);
    useEffect(() => {
        mounted.current = true;
        return () => (mounted.current = false);
    });

    const [modalMode, setModalMode] = useState(null);
    const [selectedUE, setSelectedUE] = useState(null);

    const { refreshData, users, upcomingExams } = props;

    const handleShowModal = useCallback((mode, upcomingExams) => {
        if(mounted.current){
            setModalMode(mode);
            setSelectedUE(upcomingExams);
        }
    }, [mounted]);
    const onSubmitCallback = useCallback((changes = false) => {
        if(mounted.current){
            setModalMode(null);
            setSelectedUE(null);
            if(changes) refreshData();
        }
    }, [mounted, refreshData]);

    const columns = useMemo(() => getColumns(handleShowModal, users), [users, handleShowModal]);

    return (
        <div>
            {modalMode && 
                <UpcomingExamsModal
                    mode={modalMode}
                    selectedUE={selectedUE}
                    onSubmitCallback={onSubmitCallback}
                />
            }
            <Table
                tableName="upcomingExams"
                data={upcomingExams}
                columns={columns}
                defaultSorted={defaultSorted}
                emptyMessage="No upcoming exams were found"
            />
        </div>
    );
}

export default connect(null, {

})(Component);